export const environment = {
    production: true,
    keycloakConfig:{
        realm:  'grahak',
        clientId: 'nextgenapps-cv',
        url: 'https://qa.sso.tatamotors.com/auth/',
        },
        APIUrl: '/iconnectusermgmtapi',
        baseUrl: 'https://dev-portal.cvnextgenappsqa.tatamotors.com/',
        apiBaseUri:"apiUrl",
        analyticsBaseUri:'/nextgensbanalytics',
        multiLanguage:'./assets/i18n/',
        baseSecretkey:"RuQYEGRM76CKfaIii2U4qafZzGdIbvGAU2Z+mGOgl78=",
        application:
          {
            name: 'NextGen Apps',
            version: 'Angular 17.0.8',
            environs:"staging"
          }
    };
